export default __webpack_public_path__ + "static/media/lang.75eb461a.wav";